import {EmailsList} from "./emails-list";

export class EmailsListMapper {
  public static map(data: any): EmailsList {
    let email: EmailsList = new EmailsList();
    email.id = data.id;
    email.title = data.title;
    email.enabled = data.enabled;
    email.contentType = data.email_type;
    email.recipients = data.recipient;
    email.description = data.description;
    return email;
  }

}
